export const STATUS_CELL = {
  APPLY: 'Apply Now',
};
